// UPDATED DRIVER MARKING SYSTEM  WITH PASSESD POST TEST WITH 80% .
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import {
    Container,
    Typography,
    Box,
    Paper,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Radio,
    RadioGroup,
    FormControlLabel,
    Button,
    Stepper,
    Step,
    StepLabel,
    Divider,
    Grid,
    Autocomplete,
    Alert,
    Chip,
    Tooltip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    CircularProgress
} from '@mui/material';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { saveDriverMarkingAssessment } from 'helpers/driverMarking_helper';
import { Download } from '@mui/icons-material';
import { getSingleStudent } from 'helpers/student_helper';
import { getResult } from 'helpers/exam_helper';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

const GoldAssessment = ({ students, onDriverMarkingComplete }) => {
    // State for form data
    const [formData, setFormData] = useState({
        studentId: '',
        licenceType: '',
        licenceNumber: '',
        licenceDateIssue: '',
        licenceDateExpiry: '',
        licencePlace: '',
        driverFootWearCondition: '',
        driverHygienic: '',
        driverCommunication: '',
        driverConfident: '',
        driverStress: '',
        assessments: Array(18).fill({ ok: true, score: 0, comments: '' }),
        totalPercent: '0',
        remarks: ''
    });

    const [activeStep, setActiveStep] = useState(0);
    const [loading, setLoading] = useState(false);
    const [fetchingResults, setFetchingResults] = useState(false);
    const params = useParams();

    // State for test results
    const [postTestResult, setPostTestResult] = useState(null);
    const [preTestResult, setPreTestResult] = useState(null);
    const [selectedStudent, setSelectedStudent] = useState(null);
    const [eligibilityCheckDialog, setEligibilityCheckDialog] = useState(false);
    const [calculatedTotal, setCalculatedTotal] = useState('0');
    const [studentDetails, setStudentDetails] = useState(null);

    // Assessment questions with marks
    const assessmentQuestions = [
        // { text: 'Walk around the vehicle - Cleanness of lights, number plate, windscreen; tyres, mountings, leakage, LED board, Wires', marks: 5 },
        // { text: 'Inside checks - Cleanness, Passenger seats, Handrails and grab rails, lights inside the bus, fire extinguisher, Emergency hammers, First aid kit', marks: 5 },
        { text: 'PPE & Safety Compliance - Wearing PPE kit (gloves, shoes, helmet, safety vest, glasses)', marks: 10 },
        { text: 'Tool Identification & Usage - Identifying and correctly using multimeter, torque wrench, insulated tools & insulation tester', marks: 10 },
        { text: 'Preliminary Inspection - Conducting walkaround checks – battery, tyres, lights, leaks', marks: 5 },
        { text: 'High Voltage Safety Compliance - Checking HV insulation tools, discharge stick, lock-out tag-out steps', marks: 5 },
        { text: 'Coolant & HVAC System Check - Checking coolant level', marks: 5 },
        { text: 'Wire Harness Routing Check - Inspecting harness for damage, securing clamps, correct routing', marks: 5 },
        { text: 'HV/LV Start & Shut Down Procedure - Correct Way to start & shut down the vehicle', marks: 5 },
        { text: 'LOTO Procedure  - How to Use & its applications ', marks: 5 },
        { text: 'MSD Procedure - How to Use & its applications ', marks: 5 },
        { text: 'Brake Level Check - Check Brake Drum Liner', marks: 5 },
        { text: 'Knowledge About Air Drain - How to use drain valve to release Air from Air Tank ', marks: 5 },
        { text: 'Chassis Greasing points knowledge - ', marks: 5 },
        { text: 'LV tools usage- ', marks: 5 },
        { text: 'Charging system application and their selection - ', marks: 10 },
        { text: 'Cluster meter parameter and signs knowledge - ', marks: 10 },
        { text: 'Display board FDAS system undersstanding- ', marks: 5 },
    ];

    // Steps for the stepper
    const steps = ['Select Candidate', ' Trainee Condition', 'Candidate Condition', 'Assessment', 'Review & Submit'];

    // Fetch actual exam results for a student - FIXED based on first version
    const fetchExamResults = useCallback(async (studentId) => {
        if (!studentId || !params.id) return;
        
        setFetchingResults(true);
        try {
            // Fetch student details
            const studentResponse = await getSingleStudent(studentId);
            if (studentResponse?.success) {
                setStudentDetails(studentResponse.data);
                
                // Extract driver license number from student details if available
                // Using same logic as first version
                const student = studentResponse.result?.[0];
                const tataDetails = student?.tataStudentDetailsDto;
                
                if (tataDetails?.driverDlNo) {
                    setFormData(prev => ({
                        ...prev,
                        licenceNumber: tataDetails.driverDlNo || ''
                    }));
                }
            }

            // Fetch exam results using the same pattern as first version
            // First version uses: getResult(params.id + "/" + selectedDriver?.id)
            const examResponse = await getResult(`${params.id}/${studentId}`);
            
            if (examResponse?.success) {
                console.log("Exam results:", examResponse);
                
                // Based on first version console logs, the response has structure:
                // data2?.result?.preTest and data2?.result?.postTest
                if (examResponse.result) {
                    const preTest = examResponse.result.preTest;
                    const postTest = examResponse.result.postTest;
                    
                    console.log("Pre-test:", preTest);
                    console.log("Post-test:", postTest);
                    
                    // Set pre-test result (handle both percentage and raw value)
                    if (preTest !== undefined && preTest !== null) {
                        const preTestScore = typeof preTest === 'number' ? preTest : 
                                          (preTest.percentage || preTest.score || 0);
                        setPreTestResult(parseFloat(preTestScore));
                    } else {
                        setPreTestResult(null);
                    }
                    
                    // Set post-test result
                    if (postTest !== undefined && postTest !== null) {
                        const postTestScore = typeof postTest === 'number' ? postTest : 
                                           (postTest.percentage || postTest.score || 0);
                        setPostTestResult(parseFloat(postTestScore));
                    } else {
                        setPostTestResult(null);
                    }
                }
            } else {
                console.warn("Could not fetch exam results:", examResponse);
                setPreTestResult(null);
                setPostTestResult(null);
                toast.warning("Could not fetch exam results. Please check if the student has taken the tests.");
            }
        } catch (error) {
            console.error("Error fetching exam results:", error);
            toast.error("Error loading exam results");
            setPreTestResult(null);
            setPostTestResult(null);
        } finally {
            setFetchingResults(false);
        }
    }, [params.id]);

    // Frontend validation function
    const validateDriverMarkingEligibility = useCallback((student) => {
        const studentData = student || selectedStudent;
        
        if (!studentData) {
            return {
                eligible: false,
                reason: "No student selected",
                postTestScore: 0,
                isDriverMarkingCompleted: false,
                studentName: ''
            };
        }

        // Check if driver marking already completed
        const isDriverMarkingCompleted = studentData.driverMarkingCompleted || 
                                        studentData.practicalCompleted || 
                                        (studentDetails?.driverMarkingStatus === 'completed') || 
                                        false;
        
        // Use actual post-test result or 0 if not available
        const postTestScore = postTestResult || 0;
        const numericScore = parseFloat(postTestScore);
        
        if (isDriverMarkingCompleted) {
            return {
                eligible: false,
                reason: "Practical already completed by this student",
                postTestScore: numericScore,
                isDriverMarkingCompleted: true,
                studentName: `${studentData.firstName || ''} ${studentData.lastName || ''}`
            };
        }
        
        if (numericScore < 80) {
            return {
                eligible: false,
                reason: `Post-test score ${numericScore}% is below 80% minimum requirement`,
                postTestScore: numericScore,
                isDriverMarkingCompleted: false,
                studentName: `${studentData.firstName || ''} ${studentData.lastName || ''}`
            };
        }
        
        return {
            eligible: true,
            reason: "Student is eligible for practical assessment",
            postTestScore: numericScore,
            isDriverMarkingCompleted: false,
            studentName: `${studentData.firstName || ''} ${studentData.lastName || ''}`
        };
    }, [selectedStudent, postTestResult, studentDetails]);

    // Get current eligibility
    const currentEligibility = useMemo(() => {
        return validateDriverMarkingEligibility();
    }, [validateDriverMarkingEligibility]);

    // Reset form after submission
    const resetForm = () => {
        setFormData({
            studentId: '',
            licenceType: '',
            licenceNumber: '',
            licenceDateIssue: '',
            licenceDateExpiry: '',
            licencePlace: '',
            driverFootWearCondition: '',
            driverHygienic: '',
            driverCommunication: '',
            driverConfident: '',
            driverStress: '',
            assessments: Array(18).fill({ ok: true, score: 0, comments: '' }),
            totalPercent: '0',
            remarks: ''
        });
        setPostTestResult(null);
        setPreTestResult(null);
        setSelectedStudent(null);
        setStudentDetails(null);
        setActiveStep(0);
        setCalculatedTotal('0');
    };

    // Calculate total score
    const calculateTotal = useCallback(() => {
        const maxScores = [5, 5, 5, 5, 5, 5, 5, 10, 10, 10, 10, 5, 10, 2, 2, 2, 2, 2];
        
        // const maxScores = [10, 10, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 10, 10, 5];
        let total = 0;

        formData.assessments.forEach((assessment, index) => {
            if (assessment.ok) {
                total += maxScores[index];
            } else {
                total += Math.min(maxScores[index], Math.max(0, assessment.score || 0));
            }
        });

        const totalMax = maxScores.reduce((sum, score) => sum + score, 0);
        const percentage = ((total / totalMax) * 100).toFixed(2);

        setCalculatedTotal(percentage);
        return percentage;
    }, [formData.assessments]);

    // Calculate total only when needed
    useEffect(() => {
        if (activeStep === steps.length - 1) {
            const percentage = calculateTotal();
            setFormData(prev => ({ ...prev, totalPercent: percentage }));
        }
    }, [activeStep, calculateTotal]);

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    // Handle date input changes
    const handleDateChange = (name, value) => {
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    // Handle assessment changes
    const handleAssessmentChange = useCallback((index, field, value) => {
        setFormData(prev => {
            const newAssessments = [...prev.assessments];
            newAssessments[index] = { ...newAssessments[index], [field]: value };

            if (field === 'ok' && value === false) {
                newAssessments[index].score = 0;
            }

            return { ...prev, assessments: newAssessments };
        });
    }, []);

    // Handle score input changes
    const handleScoreChange = (index, value, maxScore) => {
        const numericValue = parseInt(value) || 0;
        const clampedValue = Math.min(maxScore, Math.max(0, numericValue));
        handleAssessmentChange(index, 'score', clampedValue);
    };

    // Handle step navigation
    const handleNext = () => {
        if (activeStep === 0) {
            const eligibility = validateDriverMarkingEligibility();
            if (!eligibility.eligible) {
                setEligibilityCheckDialog(true);
                return;
            }
        }
        setActiveStep(prev => prev + 1);
    };

    const handleBack = () => setActiveStep(prev => prev - 1);

    // Handle student selection - UPDATED to match first version
    const handleSelectDriver = useCallback(async (selectedDriver) => {
        if (!selectedDriver) {
            setSelectedStudent(null);
            setPostTestResult(null);
            setPreTestResult(null);
            setStudentDetails(null);
            setFormData(prev => ({ 
                ...prev, 
                studentId: '',
                licenceNumber: '',
                licenceDateExpiry: ''
            }));
            return;
        }

        try {
            setLoading(true);
            setSelectedStudent(selectedDriver);
            
            // Set basic student info
            setFormData(prev => ({
                ...prev,
                studentId: selectedDriver?.id || ''
            }));

            // Fetch actual exam results using same pattern as first version
            await fetchExamResults(selectedDriver.id);

            // Check eligibility
            const eligibility = validateDriverMarkingEligibility(selectedDriver);
            if (!eligibility.eligible) {
                toast.warning(`Student is not eligible: ${eligibility.reason}`);
            }

        } catch (error) {
            console.error("Error loading driver data:", error);
            toast.error("Error loading student data");
        } finally {
            setLoading(false);
        }
    }, [fetchExamResults, validateDriverMarkingEligibility]);

    // Handle form submission
    const handleSubmit = async () => {
        const eligibility = validateDriverMarkingEligibility();
        
        if (!eligibility.eligible) {
            toast.error(`Cannot submit assessment: ${eligibility.reason}`);
            return;
        }

        // Ensure post-test score meets requirement
        if (!postTestResult || postTestResult < 80) {
            toast.error(`Post-test score (${postTestResult || 0}%) is below 80% requirement`);
            return;
        }

        setLoading(true);
        try {
            const payload = {
                ...formData,
                studentId: formData.studentId,
                batchId: params.id,
                postTestScore: postTestResult,
                preTestScore: preTestResult,
                calculatedPercentage: calculatedTotal
            };
            
            const data = await saveDriverMarkingAssessment(payload);
            if (data?.success) {
                toast.success(data?.message || "Assessment submitted successfully");
                
                if (onDriverMarkingComplete && selectedStudent) {
                    onDriverMarkingComplete(selectedStudent.id);
                }
                
                resetForm();
            } else {
                toast.error(data?.message || "Failed to submit assessment");
            }
        } catch (error) {
            console.error('Error saving assessment:', error);
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    // Check if next button should be disabled
    const isNextButtonDisabled = useMemo(() => {
        const eligibility = validateDriverMarkingEligibility();
        
        if (activeStep === 0) {
            if (!selectedStudent) return true;
            if (fetchingResults) return true;
            // Only check eligibility if we have postTestResult
            if (postTestResult !== null) {
                return !eligibility.eligible;
            }
            // If still loading results, disable button
            return fetchingResults;
        }
        
        if (activeStep === 1) {
            return !formData.licenceType ||
                   !formData.licenceNumber ||
                   !formData.licenceDateIssue ||
                   !formData.licenceDateExpiry ||
                   !formData.licencePlace;
        }
        
        if (activeStep === 2) {
            return !formData.driverFootWearCondition ||
                   !formData.driverHygienic ||
                   !formData.driverCommunication ||
                   !formData.driverConfident ||
                   !formData.driverStress;
        }
        
        return false;
    }, [activeStep, selectedStudent, formData, validateDriverMarkingEligibility, fetchingResults, postTestResult]);

    // Get button text
    const getNextButtonText = useMemo(() => {
        if (activeStep === 0) {
            if (fetchingResults) return "Loading Results...";
            const eligibility = validateDriverMarkingEligibility();
            if (!eligibility.eligible && selectedStudent && postTestResult !== null) {
                return "Not Eligible - View Details";
            }
            if (postTestResult === null && selectedStudent && !fetchingResults) {
                return "No Test Results Found";
            }
        }
        return "Next";
    }, [activeStep, selectedStudent, validateDriverMarkingEligibility, fetchingResults, postTestResult]);

    // Render step 0 content
    const renderStep0Content = () => {
        const eligibility = currentEligibility;
        
        return (
            <Box>
                {/* Loading indicator */}
                {fetchingResults && (
                    <Box display="flex" justifyContent="center" alignItems="center" mb={2}>
                        <CircularProgress size={24} sx={{ mr: 1 }} />
                        <Typography variant="body2">Loading exam results...</Typography>
                    </Box>
                )}

                {/* Eligibility Status Banner */}
                {selectedStudent && postTestResult !== null && (
                    <Alert 
                        severity={eligibility.eligible ? "success" : "warning"}
                        sx={{ mb: 3 }}
                        icon={eligibility.eligible ? <CheckCircleIcon /> : <WarningIcon />}
                        action={
                            <Chip 
                                label={`Post-test: ${eligibility.postTestScore}%`}
                                color={eligibility.postTestScore >= 80 ? "success" : "error"}
                                size="small"
                                variant="outlined"
                            />
                        }
                    >
                        {eligibility.reason}
                        {!eligibility.eligible && eligibility.postTestScore >= 80 && (
                            <div style={{ fontSize: '0.9em', marginTop: '4px' }}>
                                Practical already completed by this student. Next attempt after 1 year.
                            </div>
                        )}
                    </Alert>
                )}

                {selectedStudent && postTestResult === null && !fetchingResults && (
                    <Alert severity="info" sx={{ mb: 3 }}>
                        No test results found for this student. Please ensure the student has completed both pre-test and post-test.
                    </Alert>
                )}

                <Typography variant="h6" gutterBottom>
                    Select Student for Practical Assessment
                    <Tooltip title="Students must have 80% or higher in post-test and not have completed practical already. Next attempt allowed after 1 year." arrow>
                        <InfoIcon sx={{ ml: 1, fontSize: '1rem', color: 'primary.main' }} />
                    </Tooltip>
                </Typography>

                <Autocomplete
                    options={students}
                    getOptionLabel={(option) => `${option.firstName || ''} ${option.lastName || ''}`}
                    value={selectedStudent}
                    onChange={(_, newValue) => handleSelectDriver(newValue)}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Select Candidate"
                            variant="outlined"
                            required
                            placeholder="Search student by name..."
                            helperText="Select a student to begin practical assessment"
                            disabled={fetchingResults}
                        />
                    )}
                    renderOption={(props, option) => {
                        return (
                            <li {...props}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                    <Box>
                                        {option.firstName} {option.lastName}
                                        <Typography variant="body2" color="text.secondary">
                                            {option.mobile} • {option.email || 'No email'}
                                        </Typography>
                                    </Box>
                                </Box>
                            </li>
                        );
                    }}
                    loading={fetchingResults}
                    disabled={fetchingResults}
                />

                {selectedStudent && (
                    <Box sx={{ mt: 3, p: 2, border: '1px solid', borderColor: eligibility.eligible ? 'success.main' : 'warning.main', borderRadius: 1 }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Selected Student Details
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Typography variant="body2">
                                    <strong>Name:</strong> {selectedStudent.firstName} {selectedStudent.lastName}
                                </Typography>
                                <Typography variant="body2">
                                    <strong>Mobile:</strong> {selectedStudent.mobile}
                                </Typography>
                                <Typography variant="body2">
                                    <strong>Email:</strong> {selectedStudent.email || 'Not provided'}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2">
                                    <strong>Post-test Score:</strong> 
                                    <span style={{ 
                                        color: postTestResult >= 80 ? 'green' : postTestResult !== null ? 'red' : 'gray',
                                        fontWeight: 'bold',
                                        marginLeft: '8px'
                                    }}>
                                        {postTestResult !== null ? `${postTestResult}%` : 'Not found'}
                                        {postTestResult >= 80 ? ' ✓' : postTestResult !== null ? ' ✗' : ''}
                                    </span>
                                </Typography>
                                <Typography variant="body2">
                                    <strong>Pre-test Score:</strong> 
                                    <span style={{ marginLeft: '8px' }}>
                                        {preTestResult !== null ? `${preTestResult}%` : 'Not found'}
                                    </span>
                                </Typography>
                                <Typography variant="body2">
                                    <strong>Practical Status:</strong> 
                                    <span style={{ 
                                        color: eligibility.isDriverMarkingCompleted ? 'orange' : 'green',
                                        fontWeight: 'bold',
                                        marginLeft: '8px'
                                    }}>
                                        {eligibility.isDriverMarkingCompleted ? 'Already Completed' : 'Not Completed'}
                                    </span>
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                )}
            </Box>
        );
    };

    // Render step 1 content
    const renderStep1Content = () => {
        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom>Region</Typography>
                    <RadioGroup
                        name="licenceType"
                        value={formData.licenceType}
                        onClick={handleChange}
                        row
                    >
                        <FormControlLabel value="LMV" control={<Radio />} label="India" />
                        <FormControlLabel value="HMV" control={<Radio />} label="Other" />
                    </RadioGroup>
                </Grid>

                <Grid item xs={12} md={6}>
                    <TextField
                        fullWidth
                        label="Contact Number"
                        name="licenceNumber"
                        value={formData.licenceNumber}
                        onChange={handleChange}
                        required
                        helperText="Enter  your contact number"
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <TextField
                        fullWidth
                        label="Location"
                        name="licencePlace"
                        value={formData.licencePlace}
                        onChange={handleChange}
                        required
                        helperText="Enter  your Depot Name"
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <div style={{ width: '100%', marginBottom: '16px' }}>
                        <label style={{ display: 'block', fontSize: '14px', color: '#666', marginBottom: '4px' }}>
                            Training Start Date (DD-MM-YYYY)*
                        </label>
                        <input
                            type="date"
                            name="licenceDateIssue"
                            value={formData.licenceDateIssue}
                            onChange={(e) => handleDateChange('licenceDateIssue', e.target.value)}
                            required
                            placeholder="YYYY-MM-DD"
                            pattern="\d{4}-\d{2}-\d{2}"
                            style={{
                                width: '100%',
                                padding: '16.5px 14px',
                                fontSize: '16px',
                                border: '1px solid rgba(0, 0, 0, 0.23)',
                                borderRadius: '4px',
                                boxSizing: 'border-box',
                                outline: 'none',
                                transition: 'border-color 0.3s ease',
                            }}
                            onFocus={(e) => e.target.style.border = '2px solid #3f51b5'}
                            onBlur={(e) => e.target.style.border = '1px solid rgba(0, 0, 0, 0.23)'}
                        />
                    </div>
                </Grid>

                <Grid item xs={12} md={6}>
                    <div style={{ width: '100%', marginBottom: '16px' }}>
                        <label style={{ display: 'block', fontSize: '14px', color: '#666', marginBottom: '4px' }}>
                            Training End Date (DD-MM-YYYY)*
                        </label>
                        <input
                            type="date"
                            name="licenceDateExpiry"
                            value={formData.licenceDateExpiry}
                            onChange={(e) => handleDateChange('licenceDateExpiry', e.target.value)}
                            required
                            placeholder="YYYY-MM-DD"
                            pattern="\d{4}-\d{2}-\d{2}"
                            style={{
                                width: '100%',
                                padding: '16.5px 14px',
                                fontSize: '16px',
                                border: '1px solid rgba(0, 0, 0, 0.23)',
                                borderRadius: '4px',
                                boxSizing: 'border-box',
                                outline: 'none',
                                transition: 'border-color 0.3s ease',
                            }}
                            onFocus={(e) => e.target.style.border = '2px solid #3f51b5'}
                            onBlur={(e) => e.target.style.border = '1px solid rgba(0, 0, 0, 0.23)'}
                        />
                    </div>
                </Grid>
            </Grid>
        );
    };

    // Render step 2 content
    const renderStep2Content = () => {
        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom>Trainee Condition Assessment</Typography>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Typography>Shoes wear:</Typography>
                    <RadioGroup
                        name="driverFootWearCondition"
                        value={formData.driverFootWearCondition}
                        onClick={handleChange}
                        row
                    >
                        <FormControlLabel value="OK" control={<Radio />} label="OK" />
                        <FormControlLabel value="Not OK" control={<Radio />} label="Not OK" />
                    </RadioGroup>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Typography>Hygiene:</Typography>
                    <RadioGroup
                        name="driverHygienic"
                        value={formData.driverHygienic}
                        onClick={handleChange}
                        row
                    >
                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                        <FormControlLabel value="No" control={<Radio />} label="No" />
                    </RadioGroup>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Typography>Communication:</Typography>
                    <RadioGroup
                        name="driverCommunication"
                        value={formData.driverCommunication}
                        onClick={handleChange}
                        row
                    >
                        <FormControlLabel value="OK" control={<Radio />} label="OK" />
                        <FormControlLabel value="Not OK" control={<Radio />} label="Not OK" />
                    </RadioGroup>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Typography>Confident:</Typography>
                    <RadioGroup
                        name="driverConfident"
                        value={formData.driverConfident}
                        onClick={handleChange}
                        row
                    >
                        <FormControlLabel value="OK" control={<Radio />} label="OK" />
                        <FormControlLabel value="Not OK" control={<Radio />} label="Not OK" />
                    </RadioGroup>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Typography>Stress:</Typography>
                    <RadioGroup
                        name="driverStress"
                        value={formData.driverStress}
                        onClick={handleChange}
                        row
                    >
                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                        <FormControlLabel value="No" control={<Radio />} label="No" />
                    </RadioGroup>
                </Grid>
            </Grid>
        );
    };

    // Render step 3 content
    const renderStep3Content = () => {
        return (
            <Box>
                <Typography variant="h6" gutterBottom>Bronze Technical Assessment</Typography>
                <Typography variant="body2" color="text.secondary" paragraph>
                    Assess the Technical on each skill. Mark "OK" for full marks or "Not OK" for partial marks.
                </Typography>
                {assessmentQuestions.map((question, index) => (
                    <Paper key={index} elevation={2} sx={{ p: 2, mb: 2 }}>
                        <Typography fontWeight="bold">{index + 1}. {question.text}</Typography>
                        <Typography color="text.secondary">Marks: {question.marks}</Typography>

                        <RadioGroup
                            row
                            value={formData.assessments[index]?.ok ?? true}
                            onClick={(e) => handleAssessmentChange(index, 'ok', e.target.value === 'true')}
                            sx={{ mt: 1 }}
                        >
                            <FormControlLabel value={true} control={<Radio />} label={`OK (${question.marks} marks)`} />
                            <FormControlLabel value={false} control={<Radio />} label="Not OK (Partial marks)" />
                        </RadioGroup>

                        {formData.assessments[index]?.ok === false && (
                            <Box sx={{ mt: 2 }}>
                                <div style={{ display: 'flex', flexDirection: 'column', width: '120px', marginBottom: '16px' }}>
                                    <label style={{ fontSize: '14px', color: '#666', marginBottom: '4px' }}>
                                        Score (0 to {question.marks})
                                    </label>
                                    <input
                                        type="number"
                                        min="0"
                                        max={question.marks}
                                        step="1"
                                        value={formData.assessments[index]?.score || ''}
                                        onChange={(e) => handleScoreChange(index, e.target.value, question.marks)}
                                        style={{
                                            width: '100%',
                                            padding: '16.5px 14px',
                                            fontSize: '16px',
                                            border: '1px solid rgba(0, 0, 0, 0.23)',
                                            borderRadius: '4px',
                                            boxSizing: 'border-box',
                                            outline: 'none',
                                            transition: 'border-color 0.3s ease',
                                        }}
                                        onFocus={(e) => e.target.style.border = '2px solid #3f51b5'}
                                        onBlur={(e) => e.target.style.border = '1px solid rgba(0, 0, 0, 0.23)'}
                                    />
                                </div>
                            </Box>
                        )}
                    </Paper>
                ))}
            </Box>
        );
    };

    // Render step 4 content
    const renderStep4Content = () => {
        const eligibility = currentEligibility;
        const totalPercentage = calculatedTotal;
        
        return (
            <Box>
                <Typography variant="h6" gutterBottom>Review Assessment</Typography>

                {/* Student and Eligibility Summary */}
                <Paper elevation={1} sx={{ p: 2, mb: 2, bgcolor: 'background.default' }}>
                    <Typography variant="subtitle1" fontWeight="bold">
                        Student: {selectedStudent?.firstName || ''} {selectedStudent?.lastName || ''}
                    </Typography>
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <Typography variant="body2">
                                <strong>Post-test Score:</strong> {postTestResult !== null ? `${postTestResult}%` : 'Not available'}
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="body2">
                                <strong>Pre-test Score:</strong> {preTestResult !== null ? `${preTestResult}%` : 'Not available'}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="body2">
                                <strong>Eligibility:</strong> 
                                <span style={{ 
                                    color: eligibility.eligible ? 'green' : 'red',
                                    fontWeight: 'bold',
                                    marginLeft: '4px'
                                }}>
                                    {eligibility.eligible ? 'ELIGIBLE' : 'NOT ELIGIBLE'}
                                </span>
                            </Typography>
                        </Grid>
                    </Grid>
                    {!eligibility.eligible && (
                        <Alert severity="warning" sx={{ mt: 1 }}>
                            {eligibility.reason}
                        </Alert>
                    )}
                </Paper>

                <Typography variant="subtitle1">License Details:</Typography>
                <Typography>License Type: {formData.licenceType}</Typography>
                <Typography>License Number: {formData.licenceNumber}</Typography>
                <Typography>Place of Issue: {formData.licencePlace}</Typography>
                <Typography>Date of Issue: {formData.licenceDateIssue}</Typography>
                <Typography>Date of Expiry: {formData.licenceDateExpiry}</Typography>

                <Divider sx={{ my: 2 }} />

                <Typography variant="subtitle1">Driver Condition:</Typography>
                <Typography>Foot Wear: {formData.driverFootWearCondition}</Typography>
                <Typography>Hygiene: {formData.driverHygienic}</Typography>
                <Typography>Communication: {formData.driverCommunication}</Typography>
                <Typography>Confident: {formData.driverConfident}</Typography>
                <Typography>Stress: {formData.driverStress}</Typography>

                <Divider sx={{ my: 2 }} />

                <Typography variant="subtitle1">Assessment Summary:</Typography>
                {assessmentQuestions.map((question, index) => (
                    <Box key={index} sx={{ mb: 1 }}>
                        <Typography variant="body2">
                            {index + 1}. {question.text} -
                            {formData.assessments[index]?.ok ?
                                ` OK (${question.marks} marks)` :
                                ` Not OK (${formData.assessments[index]?.score || 0} marks)`
                            }
                        </Typography>
                    </Box>
                ))}

                <Divider sx={{ my: 2 }} />

                <Typography variant="subtitle1">Remarks:</Typography>
                <TextField
                    fullWidth
                    multiline
                    minRows={3}
                    placeholder="Enter your remarks or additional comments here..."
                    name="remarks"
                    value={formData.remarks}
                    onChange={handleChange}
                />

                <Divider sx={{ my: 2 }} />

                <Paper elevation={2} sx={{ p: 2, bgcolor: totalPercentage >= 80 ? 'success.light' : 'warning.light' }}>
                    <Typography variant="h6" align="center">
                        Total Percentage: {totalPercentage}%
                        {totalPercentage >= 80 ? ' ✓ PASS' : ' ✗ FAIL'}
                    </Typography>
                    <Typography variant="body2" align="center" color="text.secondary">
                        {totalPercentage >= 80 ? 
                            'Student has passed the practical assessment' : 
                            'Student has failed the practical assessment'
                        }
                    </Typography>
                </Paper>
            </Box>
        );
    };

    // Main render function for step content
    const renderStepContent = (step) => {
        switch (step) {
            case 0:
                return renderStep0Content();
            case 1:
                return renderStep1Content();
            case 2:
                return renderStep2Content();
            case 3:
                return renderStep3Content();
            case 4:
                return renderStep4Content();
            default:
                return <Typography>Unknown step</Typography>;
        }
    };

    return (
        <Container maxWidth="md" sx={{ my: 4 }}>
            <Paper elevation={3} sx={{ p: 2 }}>
                <Typography variant="h4" gutterBottom align="center">
                    Practical Assessment (Gold Technical Assessment)
                </Typography>

                {/* Requirements Banner */}
                <Alert 
                    severity="info" 
                    sx={{ mb: 3 }}
                    icon={<InfoIcon />}
                >
                    <Typography variant="subtitle2" gutterBottom>
                        Practical Assessment Requirements:
                    </Typography>
                    <ul style={{ margin: 0, paddingLeft: '20px' }}>
                        <li>Student must have 80% or higher in post-test</li>
                        <li>Practical assessment must not be completed already</li>
                        <li>If already completed, next attempt allowed after 1 year</li>
                        <li>Complete all assessment steps before submission</li>
                    </ul>
                </Alert>

                {/* Test Results Display */}
                <Box sx={{ mt: 3, mb: 3 }}>
                    <Typography variant="h6">Student Test Results</Typography>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item xs={12} md={6}>
                            <Paper sx={{ p: 2 }}>
                                <Typography variant="subtitle1" fontWeight="bold">
                                    Pre-Test Result:
                                </Typography>
                                {fetchingResults ? (
                                    <Box display="flex" alignItems="center">
                                        <CircularProgress size={20} sx={{ mr: 1 }} />
                                        <Typography>Loading...</Typography>
                                    </Box>
                                ) : (
                                    <Typography color={preTestResult ? "text.primary" : "text.secondary"}>
                                        {preTestResult !== null && preTestResult !== undefined
                                            ? `${preTestResult}%`
                                            : "Not Available"}
                                    </Typography>
                                )}
                            </Paper>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Paper sx={{ p: 2, 
                                border: '2px solid', 
                                borderColor: postTestResult >= 80 ? 'success.main' : postTestResult !== null ? 'warning.main' : 'grey.300'
                            }}>
                                <Typography variant="subtitle1" fontWeight="bold">
                                    Post-Test Result:
                                </Typography>
                                {fetchingResults ? (
                                    <Box display="flex" alignItems="center">
                                        <CircularProgress size={20} sx={{ mr: 1 }} />
                                        <Typography>Loading...</Typography>
                                    </Box>
                                ) : (
                                    <>
                                        <Typography 
                                            color={postTestResult !== null && postTestResult !== undefined 
                                                ? postTestResult >= 80 ? "success.main" : "error.main" 
                                                : "text.secondary"}
                                            fontWeight="bold"
                                            variant="h6"
                                        >
                                            {postTestResult !== null && postTestResult !== undefined
                                                ? `${postTestResult}%`
                                                : "Not Available"}
                                        </Typography>
                                        {postTestResult !== null && postTestResult !== undefined && (
                                            <Typography 
                                                variant="body2" 
                                                color={postTestResult >= 80 ? "success.main" : "error.main"}
                                                sx={{ mt: 1 }}
                                            >
                                                {postTestResult >= 80 
                                                    ? "✓ Eligible for practical assessment" 
                                                    : "✗ Minimum 80% required for practical assessment"}
                                            </Typography>
                                        )}
                                    </>
                                )}
                            </Paper>
                        </Grid>
                    </Grid>
                </Box>

                <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 4 }}>
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>

                <Box sx={{ mb: 4 }}>
                    {renderStepContent(activeStep)}
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Button
                        disabled={activeStep === 0 || fetchingResults}
                        onClick={handleBack}
                        variant="outlined"
                    >
                        Back
                    </Button>

                    {activeStep === steps.length - 1 ? (
                        <Button
                            onClick={handleSubmit}
                            variant="contained"
                            color="primary"
                            disabled={loading || !currentEligibility.eligible || !postTestResult || postTestResult < 80}
                            startIcon={currentEligibility.eligible ? <CheckCircleIcon /> : <CancelIcon />}
                        >
                            {loading ? 'Submitting...' : 'Submit Assessment'}
                        </Button>
                    ) : (
                        <Button
                            onClick={handleNext}
                            variant="contained"
                            color={isNextButtonDisabled ? "warning" : "primary"}
                            disabled={isNextButtonDisabled}
                            startIcon={isNextButtonDisabled && selectedStudent ? <WarningIcon /> : null}
                        >
                            {getNextButtonText}
                        </Button>
                    )}
                </Box>
            </Paper>

            {/* Eligibility Check Dialog */}
            <Dialog
                open={eligibilityCheckDialog}
                onClose={() => setEligibilityCheckDialog(false)}
            >
                <DialogTitle>
                    <Box display="flex" alignItems="center">
                        <WarningIcon color="warning" sx={{ mr: 1 }} />
                        Eligibility Check Failed
                    </Box>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Typography variant="body1" gutterBottom>
                            The selected student is not eligible for practical assessment.
                        </Typography>
                        <Typography variant="body2" color="error" gutterBottom>
                            <strong>Reason:</strong> {currentEligibility.reason}
                        </Typography>
                        <Typography variant="body2" paragraph>
                            <strong>Requirements:</strong>
                        </Typography>
                        <ul>
                            <li>Post-test score must be 80% or higher</li>
                            <li>Practical must not be completed already</li>
                            <li>If already completed, next attempt allowed after 1 year</li>
                        </ul>
                        <Typography variant="body2">
                            Current post-test score: <strong>{currentEligibility.postTestScore}%</strong>
                        </Typography>
                        {currentEligibility.isDriverMarkingCompleted && (
                            <Alert severity="warning" sx={{ mt: 2 }}>
                                Note: Practical already completed by this student. Next attempt allowed after 1 year from previous completion date.
                            </Alert>
                        )}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setEligibilityCheckDialog(false)} color="primary">
                        Close
                    </Button>
                    <Button 
                        onClick={() => {
                            setEligibilityCheckDialog(false);
                            setActiveStep(0);
                        }} 
                        color="primary" 
                        variant="contained"
                    >
                        Select Another Student
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
};

export default GoldAssessment;
